import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Modal,
  Typography,
} from "@mui/material";
import DiscordLogo from "../../../assets/img/discord.svg"; // Ensure path is correct

const members = [
 
  { name: "DarkNova", online: true },
  
  { name: "Ultimation", online: true },
  { name: "Nobody", online: false },
  
  { name: "GameGuard 💀", online: true },
];

const DiscordSectionsCard = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Clickable Discord Logo */}
      <Box
        component="img"
        src={DiscordLogo}
        alt="Discord"
        onClick={() => setOpen(true)}
        sx={{
          cursor: "pointer",
          width: 90,
          transition: "transform 0.3s ease",
          "&:hover": {
            transform: "scale(1.1)",
          },
        }}
      />

      {/* Modal */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: 330, sm: 500 },
            maxHeight: "90vh",
            bgcolor: "#2f3136",
            borderRadius: 2,
            p: 2,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h6"
            color="white"
            sx={{ mb: 2, textAlign: "center" }}
          >
            Discord Status & Online Players
          </Typography>

          <Divider sx={{ mb: 2, borderColor: "#444" }} />

          {/* Discord Widget */}
          <Box
            sx={{
              borderRadius: 1,
              overflow: "hidden",
              mb: 3,
              boxShadow: "0 0 5px rgba(0,0,0,0.5)",
            }}
          >
            <iframe
              src="https://discord.com/widget?id=1376412408045633576&theme=dark"
              width="100%"
              height="300"
              allowTransparency="true"
              frameBorder="0"
              sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
              title="Discord"
            ></iframe>
          </Box>

          {/* Hardcoded Members */}
          <Typography sx={{ mb: 1, color: "#ccc", fontWeight: 500 }}>
            {members.filter((m) => m.online).length} Admins online
          </Typography>

          {members.map((member, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 1,
                color: member.online ? "#90ee90" : "#888",
                opacity: member.online ? 1 : 0.6,
              }}
            >
              <Avatar
                sx={{
                  width: 28,
                  height: 28,
                  fontSize: 14,
                  bgcolor: member.online ? "#3ba55d" : "#666",
                }}
              >
                {member.name.charAt(0).toUpperCase()}
              </Avatar>
              <Typography fontSize={14}>
                {member.name}{" "}
                <Typography
                  component="span"
                  fontSize={12}
                  color={member.online ? "#4caf50" : "#aaa"}
                >
                  ({member.online ? "Online" : "Offline"})
                </Typography>
              </Typography>
            </Box>
          ))}

          <Box textAlign="center" mt={3}>
            <Button
              variant="contained"
              onClick={() => setOpen(false)}
              sx={{
                backgroundColor: "#5865F2",
                color: "#fff",
                textTransform: "none",
                px: 4,
                "&:hover": {
                  backgroundColor: "#4752c4",
                },
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DiscordSectionsCard;
